import { post,get } from '../../until/axios_instans';

//日志记录
export function postActionlog(data){
    return post('/api/ucenter/api/v1/user/action/log',data);
}
